import React, { useState } from "react";
import PdfView from "../components/PdfView";
import ChatComponent from "../components/ChatComponent";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

const DocumentView = () => {
  const [fullscreenPanel, setFullscreenPanel] = useState(null); // null, 'pdf', or 'chat'

  const toggleFullScreen = (panel) => {
    setFullscreenPanel((prev) => (prev === panel ? null : panel)); // Toggle full-screen mode
  };

  return (
    <div className="mt-[70px] w-full flex bg-[#f1f1f1]">
      <PanelGroup direction="horizontal">
        {/* PdfView Panel */}
        <Panel
          className={`pdfViewCol ${
            fullscreenPanel === "pdf" ? "w-full" : "w-auto"
          }`}
          style={{
            display: fullscreenPanel === "chat" ? "none" : "block",
          }}
        >
          <PdfView
            fullscreenPanel={fullscreenPanel}
            onToggleFullScreen={() => toggleFullScreen("pdf")}
          />
        </Panel>

        {/* Resizable Handle (hidden in full-screen mode) */}
        {fullscreenPanel === null && (
          <PanelResizeHandle className="handlerCol" />
        )}

        {/* ChatComponent Panel */}
        <Panel
          className={`chatCol ${
            fullscreenPanel === "chat" ? "w-full" : "w-auto"
          }`}
          style={{
            display: fullscreenPanel === "pdf" ? "none" : "block",
          }}
        >
          <ChatComponent
            fullscreenPanel={fullscreenPanel}
            onToggleFullScreen={() => toggleFullScreen("chat")}
          />
        </Panel>
      </PanelGroup>
    </div>
  );
};

export default DocumentView;
